import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData } from '../Services/api';

const CustomerView = () => {
    const { id } = useParams();
    const [customer, setCustomer] = useState(null);
    const [callHistory, setCallHistory] = useState([]);
    const [visitHistory, setVisitHistory] = useState([]);
    const [activeTab, setActiveTab] = useState('details'); // 'details' | 'calls' | 'visits'

    const fetchCustomerDetails = async () => {
        try {
            const res = await getData(`/customers/details/${id}`);
            if (res.success) {
                setCustomer(res.data);
                setCallHistory(res.callHistory || []);
                setVisitHistory(res.visitHistory || []);
            }
        } catch (error) {
            console.log("error fetch customer details", error);
        }
    };

    useEffect(() => {
        fetchCustomerDetails();
    }, [id]);

    if (!customer) return <div className="pc-container"><p>Loading...</p></div>;

    const formatDateTime = (d) => d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : '-';

    const statusBadge = (status, type) => {
        const colors = {
            connected: '#28a745', not_connected: '#dc3545', voice_call: '#17a2b8',
            order_received: '#28a745', order_not_received: '#dc3545', order_pending: '#ffc107',
            visited: '#28a745', pending: '#ffc107', skipped: '#dc3545', complete: '#28a745',
        };
        const bg = colors[status] || '#6c757d';
        return (
            <span style={{ background: bg, color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 }}>
                {status ? status.replace(/_/g, ' ').toUpperCase() : '-'}
            </span>
        );
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/customer/customer-list">Customer</Link></li>
                                    <li className="breadcrumb-item" aria-current="page">Customer Details</li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Customer Details</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">

                                {/* ✅ Tabs */}
                                <ul className="nav nav-tabs mb-4">
                                    <li className="nav-item">
                                        <button className={`nav-link ${activeTab === 'details' ? 'active' : ''}`} onClick={() => setActiveTab('details')}>
                                            <i className="fas fa-user me-1" /> Details
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button className={`nav-link ${activeTab === 'calls' ? 'active' : ''}`} onClick={() => setActiveTab('calls')}>
                                            <i className="fas fa-phone me-1" /> Call History
                                            <span className="badge bg-primary ms-1">{callHistory.length}</span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button className={`nav-link ${activeTab === 'visits' ? 'active' : ''}`} onClick={() => setActiveTab('visits')}>
                                            <i className="fas fa-map-marker-alt me-1" /> Visit History
                                            <span className="badge bg-success ms-1">{visitHistory.length}</span>
                                        </button>
                                    </li>
                                </ul>

                                {/* ── Details Tab ── */}
                                {activeTab === 'details' && (
                                    <>
                                        <div className="row">
                                            <div className="col-sm-12 text-center mb-3">
                                                <div className="user-upload wid-75">
                                                    <img src={avtar5} alt="img" className="img-fluid" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Customer Name</label>
                                                    <input type="text" className="form-control" value={customer.name || ''} disabled />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Customer Type</label>
                                                    <input type="text" className="form-control" value={customer.customer_type || ''} disabled />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Phone Numbers</label>
                                                    <input type="text" className="form-control" value={customer.phone_numbers?.join(", ") || ''} disabled />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Address</label>
                                                    <input type="text" className="form-control" value={customer.address || ''} disabled />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Created By</label>
                                                    <input type="text" className="form-control" value={customer.createdBy?.username || '-'} disabled />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Route</label>
                                                    <input type="text" className="form-control" value={customer.route?.route_name || '-'} disabled />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <h5>Notes</h5>
                                                {customer.notes?.length > 0 ? (
                                                    <ul className="list-group">
                                                        {customer.notes.map((note, index) => (
                                                            <li key={index} className="list-group-item">
                                                                <strong>{note.title}</strong><br />
                                                                {note.description}<br />
                                                                <small>{new Date(note.createdAt).toLocaleString()}</small>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : <p>No notes available.</p>}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* ── Call History Tab ── */}
                                {activeTab === 'calls' && (
                                    <div className="table-responsive">
                                        {callHistory.length === 0 ? (
                                            <p className="text-center text-muted mt-4">No call history found for this customer.</p>
                                        ) : (
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Salesperson</th>
                                                        <th>Called At</th>
                                                        <th>Call Outcome</th>
                                                        <th>Order Status</th>
                                                        <th>Duration</th>
                                                        <th>Note</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {callHistory.map((c, i) => (
                                                        <tr key={c.id}>
                                                            <td>{i + 1}</td>
                                                            <td>{c.callUser?.username || '-'}</td>
                                                            <td>{formatDateTime(c.calledAt)}</td>
                                                            <td>{statusBadge(c.call_outcome || c.connectStatus)}</td>
                                                            <td>{statusBadge(c.order_status)}</td>
                                                            <td>{c.durationSeconds ? `${Math.floor(c.durationSeconds / 60)}m ${c.durationSeconds % 60}s` : '-'}</td>
                                                            <td>{c.note || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                )}

                                {/* ── Visit History Tab ── */}
                                {activeTab === 'visits' && (
                                    <div className="table-responsive">
                                        {visitHistory.length === 0 ? (
                                            <p className="text-center text-muted mt-4">No visit history found for this customer.</p>
                                        ) : (
                                            <table className="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>S.No.</th>
                                                        <th>Salesperson</th>
                                                        <th>Check-In</th>
                                                        <th>Check-Out</th>
                                                        <th>Order Status</th>
                                                        <th>Visited</th>
                                                        <th>Notes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {visitHistory.map((v, i) => (
                                                        <tr key={v.id}>
                                                            <td>{i + 1}</td>
                                                            <td>{v.visitUser?.username || '-'}</td>
                                                            <td>{formatDateTime(v.checkInAt)}</td>
                                                            <td>{formatDateTime(v.checkOutAt)}</td>
                                                            <td>{statusBadge(v.order_status)}</td>
                                                            <td>
                                                                <span style={{ color: v.visited ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                                                    {v.visited ? '✓ Yes' : '✗ No'}
                                                                </span>
                                                            </td>
                                                            <td>{v.notes || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerView;